import {
  type CreateWorkplaceExternalIntegrationRequest,
  CreateWorkplaceExternalIntegrationRequestSchema,
  CreateWorkplaceExternalIntegrationResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { post } from "@src/appV2/api/parsedApi";
import { getWorkplaceExternalIntegrationsUrl } from "@src/appV2/ExternalIntegrations/api/useGetWorkplaceExternalIntegrations";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { useMutation, useQueryClient } from "@tanstack/react-query";

interface UseCreateWorkplaceExternalIntegrationParams {
  workplaceId: string;
  attributes: CreateWorkplaceExternalIntegrationRequest["data"]["attributes"];
}

export function useCreateWorkplaceExternalIntegration() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UseCreateWorkplaceExternalIntegrationParams) => {
      const { workplaceId, attributes } = params;

      const url = getWorkplaceExternalIntegrationsUrl(workplaceId);
      const response = await post({
        url,
        data: {
          data: {
            type: "workplace-external-integration" as const,
            attributes,
          },
        },
        bodySchema: CreateWorkplaceExternalIntegrationRequestSchema,
        responseSchema: CreateWorkplaceExternalIntegrationResponseSchema,
      });

      return response.data;
    },
    onSuccess: (_data, params) => {
      void queryClient.invalidateQueries({
        queryKey: [getWorkplaceExternalIntegrationsUrl(params.workplaceId)],
      });
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.CREATE_WORKPLACE_EXTERNAL_INTEGRATION_FAILURE,
    },
  });
}
